import React, { useState, useEffect } from "react";
import Index from "../../../Index";
import DynamicTitle from "../../../../component/seo/DynamicTitle";
import EInvoiceJsonModal from "../../../../component/common/model/JSONViewModel"; // <--- 1. Modal Import
import {
  deleteSalesVoucherEntryApiHandler,
  generateCreditNoteEInvoiceApiHandler,
  getSalesVoucherEntryListApiHandler,
  generateCreditNoteEInvoiceJsonApiHandler, // <--- 2. JSON API Import (Assuming this exists in services)
} from "../../../../services/AdminIndex";
import { toast } from "react-toastify";
import moment from "moment";

function paginate(array, rowsPerPage, page_number) {
  return array.slice(
    (page_number - 1) * rowsPerPage,
    page_number * rowsPerPage
  );
}

export default function CreditNoteVoucherList() {
  const dispatch = Index.useDispatch();
  const navigate = Index.useNavigate();
  const { token, permissions, selectedYearStart, selectedYearEnd } =
    Index.useSelector((state) => {
      return state.ERPAdminReducer;
    });

  const [page, setPage] = useState(1);

  const [salesVoucherEntryData, setSalesVoucherEntryData] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  // <--- 3. Modal State Variables
  const [eInvoiceModal, setEInvoiceModal] = useState(false);
  const [eInvoiceJson, setEInvoiceJson] = useState(null);
  const [isLoadingJson, setIsLoadingJson] = useState(false);
  const [currentId, setCurrentId] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalButtonText, setModalButtonText] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getSalesVoucherEntryData = (id) => {
    dispatch({ type: "LOADER_START" });
    getSalesVoucherEntryListApiHandler(
      token,
      0,
      1,
      "creditNote",
      selectedYearStart,
      selectedYearEnd
    ).then((response) => {
      if (response.status === 201 || response.status === 200) {
        setSalesVoucherEntryData(response?.data);

        dispatch({ type: "LOADER_END" });
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
      }
    });
  };

  useEffect(() => {
    getSalesVoucherEntryData();
  }, [selectedYearStart]);

  useEffect(() => {
    setSearchedData(salesVoucherEntryData);
    setFilterData(salesVoucherEntryData?.reverse());
  }, [salesVoucherEntryData]);

  // ************** Search functions *****************
  const handleSearchData = (search) => {
    const result = searchedData.filter((item) => {
      return (
        (item?.voucherNo || "").toLowerCase().includes(search?.toLowerCase()) ||
        (item?.partyName || "").toLowerCase().includes(search?.toLowerCase()) ||
        (item?.salesAccountName || "")
          .toString()
          .toLowerCase()
          .includes(search?.toLowerCase())
      );
    });
    setFilterData(result);
    setPage(1);
  };

  const rowsPerPage = 10;

  useEffect(() => {
    setFilterData(searchedData);
  }, [page, searchedData]);

  const deleteSalesVoucherEntry = (id) => {
    dispatch({ type: "LOADER_START" });
    deleteSalesVoucherEntryApiHandler(token, id).then((response) => {
      if (response.status === 201 || response.status === 200) {
        toast.success("Sales entry deleted successfully");
        dispatch({ type: "LOADER_END" });
        getSalesVoucherEntryData();
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
      }
    });
  };

  // Delete Record function
  const deletehandler = async (id) => {
    Index.Swal.fire({
      title: "",
      text: "Are you sure you want to delete this record ?",
      icon: "",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
    }).then(async (result) => {
      if (result.isConfirmed) {
        deleteSalesVoucherEntry(id);
      }
    });
  };

  // <--- 4. Function to Open Modal & Fetch JSON
  const handleOpenEInvoiceModal = (id) => {
    setCurrentId(id);
    setModalTitle("Generate Credit Note E-Invoice JSON");
    setModalButtonText("Generate E-Invoice");
    setIsLoadingJson(true);
    setEInvoiceJson(null);
    setEInvoiceModal(true);

    generateCreditNoteEInvoiceJsonApiHandler(token, id)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          setEInvoiceJson(response?.data || response);
        } else {
          dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
          setEInvoiceModal(false);
        }
      })
      .finally(() => {
        setIsLoadingJson(false);
      });
  };

  // <--- 5. Function to Confirm Generation (Called by Modal)
  const handleGenerateEInvoice = async () => {
    dispatch({ type: "LOADER_START" });
    generateCreditNoteEInvoiceApiHandler(token, currentId).then((response) => {
      if (response.status === 201 || response.status === 200) {
        toast.success(response.message);
        dispatch({ type: "LOADER_END" });
        getSalesVoucherEntryData();
        setEInvoiceModal(false); // Close modal after success
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
      }
    });
  };

  return (
    <>
      <DynamicTitle title="ERP Sales Voucher voucherNoEntry" />
      <Index.Box className="main_content">
        <Index.Box className="page-title-main">
          <Index.Box className="flex-justify">
            <Index.Typography variant="h4" component="h4">
              Credit Note
            </Index.Typography>
            <Index.Box className="global-seach-flex">
              <Index.Box className="search-input form-group">
                <Index.TextField
                  fullWidth
                  id="fullWidth"
                  className="custom-form-control search_control"
                  placeholder="Search"
                  onChange={(e) => handleSearchData(e.target.value)}
                />
                <Index.Box className="search_btn">
                  <Index.Button className="btn_search">
                    <img
                      src={Index.Png.Search}
                      className="search"
                      disableRipple
                    ></img>
                  </Index.Button>
                </Index.Box>
              </Index.Box>

              {permissions?.includes("voucher_entry_credit_note_add") && (
                <Index.LinearButton
                  btnLabel="Add"
                  onClick={() => {
                    navigate("/dashboard/generate-credite-note-voucher");
                  }}
                  className="btn-primary"
                />
              )}
            </Index.Box>
          </Index.Box>
        </Index.Box>

        <Index.Box className="web-main-content">
          <Index.Box className="over-text-scroll">
            <Index.Box className="admin-dashboard-list-row">
              <Index.Box sx={{ width: 1 }} className="grid-main">
                <Index.Box
                  display="grid"
                  className="display-row"
                  gridTemplateColumns="repeat(12, 1fr)"
                  gap={{ xs: 2, sm: 2, md: 0, lg: 0 }}
                >
                  <Index.Box
                    gridColumn={{
                      xs: "span 12",
                      sm: "span 12",
                      md: "span 12",
                      lg: "span 12",
                    }}
                    className="grid-column"
                  >
                    <Index.Box className="report-main-box">
                      <Index.Box className="page-table-main credit-note-list-table-main">
                        <Index.TableContainer
                          component={Index.Paper}
                          className="table-container padding-container"
                        >
                          <Index.Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                            className="table"
                          >
                            <Index.TableHead className="table-head">
                              <Index.TableRow className="table-row">
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="3%"
                                >
                                  Sr.
                                </Index.TableCell>
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                >
                                  Voucher No.
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                >
                                  Date
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                >
                                  Party
                                </Index.TableCell>
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                >
                                  Amount
                                </Index.TableCell>
                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                >
                                  Sales Acc.
                                </Index.TableCell>

                                <Index.TableCell
                                  component="th"
                                  variant="th"
                                  className="table-th"
                                  width="8%"
                                  align='right'
                                >
                                  Action
                                </Index.TableCell>
                              </Index.TableRow>
                            </Index.TableHead>

                            <Index.TableBody className="table-body">
                              {filterData?.length > 0 ? (
                                paginate(filterData, rowsPerPage, page)?.map(
                                  (row, index) => (
                                    <Index.TableRow key={row?.id}>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="table-td"
                                      >
                                        {(page - 1) * rowsPerPage + index + 1}
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                      >
                                        {row?.voucherNo}
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                      >
                                        {moment(row?.voucherDate).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                      >
                                        {row?.partyName}
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                      >
                                        {row?.totalAmount}
                                      </Index.TableCell>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                      >
                                        {row?.salesAccountName}
                                      </Index.TableCell>

                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        className="table-td"
                                        align='right'
                                      >
                                        <Index.Box className="userdata-btn-flex">
                                          {/* Edit Icon */}
                                          <Index.Tooltip
                                            title="Preview"
                                            placement="bottom"
                                            arrow
                                          >
                                            <Index.Link
                                              className="table-btns table-view-btn"
                                              disableRipple
                                              to={`/dashboard/credit-not-print/${row?.id}`}
                                            >
                                              <img
                                                src={Index.Svg.whiteeye}
                                                className="table-icons"
                                              ></img>
                                            </Index.Link>
                                          </Index.Tooltip>
                                          {permissions?.includes(
                                            "voucher_entry_credit_note_edit"
                                          ) ? (
                                            <Index.Tooltip
                                              title="Edit"
                                              placement="bottom"
                                              arrow
                                            >
                                              <Index.Link
                                                className="table-btns table-edit-btn"
                                                disableRipple
                                                to={`/dashboard/edit-credite-note-voucher/${row?.id}`}
                                              >
                                                <img
                                                  src={Index.Svg.whiteedit}
                                                  className="table-icons"
                                                ></img>
                                              </Index.Link>
                                            </Index.Tooltip>
                                          ) : (
                                            <Index.Box
                                              className="table-btns table-edit-btn table-disabled-btn"
                                              disableRipple
                                            >
                                              <img
                                                src={Index.Svg.whiteedit}
                                                className="table-icons"
                                              ></img>
                                            </Index.Box>
                                          )}

                                          {/* Delete Icon */}
                                          {permissions?.includes(
                                            "voucher_entry_credit_note_delete"
                                          ) ? (
                                            <Index.Tooltip
                                              title="Delete"
                                              placement="bottom"
                                              arrow
                                            >
                                              <Index.Link
                                                className="table-btns table-trash-btn"
                                                disableRipple
                                                onClick={() => {
                                                  deletehandler(row?.id);
                                                }}
                                              >
                                                <img
                                                  src={Index.Svg.whitetrash}
                                                  className="table-icons"
                                                ></img>
                                              </Index.Link>
                                            </Index.Tooltip>
                                          ) : (
                                            <Index.Box
                                              className="table-btns table-trash-btn table-disabled-btn"
                                              disableRipple
                                            >
                                              <img
                                                src={Index.Svg.whitetrash}
                                                className="table-icons"
                                              ></img>
                                            </Index.Box>
                                          )}

                                          {/* Generate E-Invoice Icon */}
                                          <Index.Tooltip
                                            title="Generate E-Invoice"
                                            placement="bottom"
                                            arrow
                                          >
                                            <Index.Link
                                              className="table-btns table-bill-btn"
                                              disableRipple
                                              onClick={() => {
                                                // <--- 6. Updated onClick to open Modal
                                                handleOpenEInvoiceModal(
                                                  row?.id
                                                );
                                              }}
                                            >
                                              <img
                                                src={Index.Svg.generatBill}
                                                className="table-icons"
                                              ></img>
                                            </Index.Link>
                                          </Index.Tooltip>
                                        </Index.Box>
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )
                                )
                              ) : (
                                <Index.TableRow>
                                  <Index.TableCell
                                    className="no-record-found-text"
                                    colSpan={7}
                                    align="center"
                                  >
                                    <p className="not-found-para">No record found</p>
                                  </Index.TableCell>
                                </Index.TableRow>
                              )}
                            </Index.TableBody>
                          </Index.Table>
                        </Index.TableContainer>
                        {filterData?.length > rowsPerPage && (
                          <>
                            <Index.Box className="pagination-table-design">
                              <Index.Stack spacing={2} className="stack-pagination">
                                <Index.Pagination
                                  count={Math.ceil(
                                    filterData?.length / rowsPerPage
                                  )}
                                  page={page}
                                  onChange={handleChangePage}
                                  variant="outlined"
                                  shape="rounded"
                                  className="stack-pagination-list"
                                />
                              </Index.Stack>
                            </Index.Box>
                          </>
                        )}
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      {/* <--- 7. Added Modal Component */}
      <EInvoiceJsonModal
        open={eInvoiceModal}
        handleClose={() => setEInvoiceModal(false)}
        handleConfirm={handleGenerateEInvoice}
        jsonData={eInvoiceJson}
        isLoading={isLoadingJson}
        modelTitle={modalTitle}
        ButtonText={modalButtonText}
      />
    </>
  );
}